export default __webpack_public_path__ + "static/media/upsell-background.afc2098e.png";